import {graphql} from "babel-plugin-relay/macro";

export const CREATE_BRANCH_ROOT_NODE_MUTATION = graphql`
    mutation projectCreateTreeButton_CreateBranchRootNodeMutation(
        $input: PaediaPredefinedTemplateCreateBranchRootNodeInput!
        $connections: [ID!]!
    ) {
        Admin {
            Tree {
                paediaPredefinedTemplateCreateBranchRootNode(input: $input) {
                    createdRootNode @appendEdge(connections: $connections) {
                        node {
                            id
                            ...RootNodesTable_TreeNodeFragment
                        }
                    }
                }
            }
        }
    }
`;
